import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";
import { resolveImage } from "@/lib/image";

const SESSION_KEY = "maharlika_popup_seen";

export default function PopupAd() {
  const [ad, setAd] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    api.get("/popup-ads").then(({ data }) => {
      if (data?.length) {
        setAd(data[0]);
        setTimeout(() => setOpen(true), 1200);
      }
    }).catch(() => {});
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem(SESSION_KEY, "1");
  };

  if (!ad || !open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 animate-in fade-in duration-300" data-testid="popup-ad">
      <div className="relative w-full max-w-md bg-[#050505] border border-[#D4AF37]/40 shadow-[0_0_40px_rgba(212,175,55,0.25)]">
        <button data-testid="popup-close" onClick={close} className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-full">
          <X className="w-5 h-5" />
        </button>
        {ad.image && (
          <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${resolveImage(ad.image)})` }} />
        )}
        <div className="p-7 text-center">
          <div className="badge-royal inline-block mb-3">Limited Offer</div>
          <h3 className="font-heading text-3xl text-[#D4AF37] mb-2">{ad.title}</h3>
          <p className="text-sm text-[#FAF9F6]/70 leading-relaxed mb-5">{ad.description}</p>
          <a
            href={ad.button_link || "/"}
            data-testid="popup-cta"
            onClick={close}
            className="btn-chow inline-block"
          >{ad.button_text || "Learn More"}</a>
        </div>
      </div>
    </div>
  );
}
